import { useQuery } from 'data-fetching-client';
import { BATCH_GET_OBJECT_TYPES_BY_IDS } from 'automation-ui-references/object-type-properties/ObjectTypesQueries';
import getAssociationLabelOptions from 'automation-ui-associations/utils/getAssociationLabelOptions';
import { useAssociationDefinitions } from 'automation-ui-associations/hooks/associationDefinitionsHooks';
const useAssociationLabelOptions = ({
  fromObjectTypeId,
  fromCardinality,
  toObjectTypeIds,
  hasReachedAssociationLimit,
  value,
  supportsNonFlexibleAssociations,
  shouldUseAlternateAllAssociationsLabel,
  objectTypesWithNoOneToManyTargetSpecs
}) => {
  var _toObjectTypesDefinit;
  const {
    data: toObjectTypesDefinitionData,
    loading: dataLoading
  } = useQuery(BATCH_GET_OBJECT_TYPES_BY_IDS, {
    skip: !toObjectTypeIds.length,
    variables: {
      objectTypeIds: toObjectTypeIds,
      skipImmutableFormatting: true
    }
  });
  const associationDefinitionsQuery = useAssociationDefinitions([fromObjectTypeId]);
  const optionsLoading = dataLoading || associationDefinitionsQuery.loading;
  let options = (toObjectTypesDefinitionData === null || toObjectTypesDefinitionData === void 0 || (_toObjectTypesDefinit = toObjectTypesDefinitionData.batchObjectTypesByIds) === null || _toObjectTypesDefinit === void 0 ? void 0 : _toObjectTypesDefinit.map(toObjectType => {
    /**
     * This flag is used to disable the association when the
     * source spec is a one-to-many association but the
     * target specs only contain one-to-one associations.
     */
    const disallowOneToMany = objectTypesWithNoOneToManyTargetSpecs === null || objectTypesWithNoOneToManyTargetSpecs === void 0 ? void 0 : objectTypesWithNoOneToManyTargetSpecs.includes(toObjectType.objectTypeId);
    return {
      text: toObjectType.pluralForm || toObjectType.singularForm || '',
      options: getAssociationLabelOptions({
        associationDefinitionsQuery,
        fromObjectTypeId,
        fromCardinality,
        toObjectTypeId: toObjectType.objectTypeId,
        toObjectTypeDefinition: toObjectType,
        value,
        supportsNonFlexibleAssociations,
        hasReachedAssociationLimit,
        shouldUseAlternateAllAssociationsLabel,
        disallowOneToMany
      })
    };
  })) || [];
  if (options.length === 1) {
    options = options[0].options;
  }
  return [options, optionsLoading];
};
export default useAssociationLabelOptions;